import React from 'react';
import Popover from '../Popover';
import { PopoverProps } from '../Popover/PopoverTypes';

export interface MenuProps
    extends React.PropsWithChildren<
        Pick<
            PopoverProps,
            'open' | 'anchor' | 'matchWidth' | 'isDismissable' | 'onClose' | 'offset' | 'anchorDisplay' | 'margin'
        >
    > {
    trigger: Exclude<PopoverProps['trigger'], 'hover'>;
}

export function Menu({ children, anchor, ...otherProps }: MenuProps): JSX.Element {
    return (
        <Popover verticalOverflow padding="none" anchor={anchor} content={children as JSX.Element} {...otherProps} />
    );
}

Menu.defaultProps = {
    trigger: 'click',
    isDismissible: true,
    anchorDisplay: 'inline-block',
};
